import script from "./AccordionCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccordionCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./AccordionCheckbox.vue?vue&type=style&index=0&id=429d9c5f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-429d9c5f"]])

export default __exports__